const config = {
    siteName: process.env.SITE_NAME,
    apiBaseURL: process.env.API_BASE_URL,

}
export default config;

// Phonak Commands
// Local API
// npm start -- --env site=phonak --env target=local

// Development API
// npm start -- --env site=phonak --env target=dev

// Live API
// npm start -- --env site=phonak --env target=live


// Unitron Commands
// Local API
// npm start -- --env site=unitron --env target=local

// Development API
// npm start -- --env site=unitron --env target=dev

// Live API
// npm start -- --env site=unitron --env target=live


// Phonak Build Commands
// Local API
// npm run build -- --env site=phonak --env target=local

// Development API
// npm run build -- --env site=phonak --env target=dev

// Live API
// npm run build -- --env site=phonak --env target=live


// Unitron Build Commands
// Local API
// npm run build -- --env site=unitron --env target=local

// Development API
// npm run build -- --env site=unitron --env target=dev

// Live API
// npm run build -- --env site=unitron --env target=live
